/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PromotionAwardRequestDto
 */
export interface PromotionAwardRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PromotionAwardRequestDto
     */
    'type': PromotionAwardRequestDtoTypeEnum;
}

export const PromotionAwardRequestDtoTypeEnum = {
    Telegram: 'TELEGRAM'
} as const;

export type PromotionAwardRequestDtoTypeEnum = typeof PromotionAwardRequestDtoTypeEnum[keyof typeof PromotionAwardRequestDtoTypeEnum];


